import { Card, Anchor, Text } from "@doar/components";
import { StyledBody, StyledIcon, StyledFooter } from "./style";

interface IProps {
    icon: string;
    title: string;
    desc: string;
    topics: string | number;
    path?: string;
}

const HelpBox = ({ icon, title, desc, topics, path = "!#" }: IProps) => {
    return (
        <Card>
            <StyledBody>
                <StyledIcon>
                    <i className={`fa ${icon}`} />
                </StyledIcon>
                <h5>
                    <Anchor path="#!" variant="link1">
                        {title}
                    </Anchor>
                </h5>
                <Text color="text3">{desc}</Text>
            </StyledBody>
            <StyledFooter>
                <span>{topics}</span>
                <Anchor path={path}>
                    <i className="fa fa-arrow-right" />
                </Anchor>
            </StyledFooter>
        </Card>
    );
};

export default HelpBox;
